'use client';

import Image from 'next/image';
import { AD_SETTINGS } from '@/lib/adSlots';
import AdHeader from '../AdHeader';

export default function DiscoverCarsAd() {
  return (
    <a
      href={AD_SETTINGS.discovercarsUrl}
      target="_blank"
      rel="sponsored nofollow noopener noreferrer"
      className="group block"
    >
      <AdHeader title="Find a rental car nearby" />

      <div className="relative aspect-[620/356] w-full overflow-hidden">
        <Image
          src="/images/car-rental.png"
          alt="Discover Cars car rental"
          fill
          sizes="(max-width: 1024px) 100vw, 350px"
          className="object-cover transition-transform duration-300 group-hover:scale-105"
        />
      </div>

      <div>
        <p className="mb-3 text-sm text-gray-600 dark:text-gray-400">
          Compare hundreds of car rental companies worldwide and save up to 70% on your hire car.
        </p>
        <span className="inline-block w-full rounded-lg bg-forest-green-600 px-4 py-2 text-center text-sm font-semibold text-white transition-colors group-hover:bg-forest-green-700">
          Rent a car
        </span>
      </div>
    </a>
  );
}
